import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import './ContactPage.css';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // TODO: hook up to your backend/email service here

    // Simple success feedback (replace with toast if you have one)
    alert('Thanks! Your message has been sent.');

    setForm({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-page">
      <NavBar />

      <main className="contact-section">
        <header className="contact-header">
          <h1>Get in Touch</h1>
          <p>We'd love to hear from you — feedback, ideas, collaboration, anything!</p>
        </header>

        <section className="contact-card" aria-label="Contact form">
          <h2 className="contact-title">Contact Us</h2>

          <form className="contact-form" onSubmit={onSubmit}>
            <label htmlFor="name" className="form-label">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              className="form-input"
              placeholder="Your name"
              value={form.name}
              onChange={onChange}
              required
            />

            <label htmlFor="email" className="form-label">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-input"
              placeholder="you@example.com"
              value={form.email}
              onChange={onChange}
              required
            />

            <label htmlFor="message" className="form-label">Message</label>
            <textarea
              id="message"
              name="message"
              className="form-textarea"
              placeholder="Your message…"
              rows={5}
              value={form.message}
              onChange={onChange}
              required
            />

            <button type="submit" className="contact-button">Send Message</button>
          </form>
        </section>

        <aside className="contact-info" aria-label="Other ways to reach us">
          <h3>Other Ways to Reach Us</h3>
          <ul>
            <li>📧 support@logisim.com</li>
            <li>🌐 www.logisim.io</li>
            <li>📍 Melbourne, Australia</li>
          </ul>
        </aside>
      </main>

      <Footer />
    </div>
  );
}